module.exports = __webpack_public_path__ + "static/media/rim-back-right.ff3162a5.jpg";